import C5BaseDAO from "./C5BaseDAO";
import CarrinhoItemModel from "../../model/CarrinhoItemModel";
import CarrinhoModel from "../../model/CarrinhoModel";
import AppState from "../../model/AppState";
import LojaModel from "../../model/LojaModel";
import ProdutoModel from "../../model/ProdutoModel";
import C5ProdutoDAO from "./C5ProdutoDAO";

class C5CarrinhoDAO extends C5BaseDAO {
  private static instance: C5CarrinhoDAO;
  private endpoint = `${super.getBasePath()}/Basket`;

  private constructor() {
    super();
  }

  public static getInstance(): C5CarrinhoDAO {
    if (!C5CarrinhoDAO.instance) {
      C5CarrinhoDAO.instance = new C5CarrinhoDAO();
    }
    return C5CarrinhoDAO.instance;
  }

  public async addCarrinhoItem(item: CarrinhoItemModel): Promise<string> {
    return this.post(
      "REQ_C5_CARRINHO_ITEM_ADICIONAR",
      this.endpoint,
      CarrinhoItemModel.toC5CarrinhoItemModel(item)
    ).then((r: any) => r.data.UIDBasket).catch(r => {
      throw r.response.data.ExceptionMessage
    });
  }

  public async updateCarrinhoItem(item: CarrinhoItemModel): Promise<string> {
    const carrinhoItem = CarrinhoItemModel.toC5CarrinhoItemModel(item);
    if (!carrinhoItem.ItemNote || carrinhoItem.ItemNote.length === 0) {
      delete carrinhoItem.ItemNote;
    }
    
    return this.patch(
      "REQ_C5_CARRINHO_ITEM_ATUALIZAR",
      this.endpoint,
      carrinhoItem
    ).then((r: any) => r.data.UIDBasket).catch(r => {
      throw r.response.data.ExceptionMessage
    });
  }

  public async remCarrinhoItem(item: CarrinhoItemModel): Promise<string> {
    return this.delete(
      "REQ_C5_CARRINHO_ITEM_EXCLUIR",
      this.endpoint,
      CarrinhoItemModel.toC5CarrinhoItemModel(item)
    ).then((r: any) => r.data.UIDBasket);
  }

  public async remCarrinhoItemAny(item: any): Promise<string> {
    return this.delete(
      "REQ_C5_CARRINHO_ITEM_EXCLUIR",
      this.endpoint,
      item
    ).then((r: any) => r.data.UIDBasket);
  }

  public async limparItensZerados(c: any, loja: LojaModel): Promise<any> {
    const carrinho: CarrinhoModel = AppState.getCarrinho();

    if (c && c.data && c.data.products && c.data.products.length > 0) {
      const zerados: any = c.data.products.filter(
        (p: any) => p.ItemQuantity === 0
      );

      if (zerados) {
        const allproms: any = [];

        zerados.map((z: any) => {
          allproms.push(
            this.remCarrinhoItemAny({
              ProductID: +z.ProductID,
              StoreID: +z.StoreID,
              ItemQuantity: +z.ItemQuantity,
              UIDBasket: carrinho.carrinhoId,
            })
          );
          return z;
        });

        Promise.all(allproms)
          .then(() => {
            const carrinhoEndpoint: string = `${this.endpoint}/?UIDBasket=${carrinho.carrinhoId}&StoreID=${loja.lojaId}`;
            return this.get(
              `REQ_C5_CARRINHO_${carrinho.carrinhoId}`,
              carrinhoEndpoint
            );
          })
          .catch(() => {
            const carrinhoEndpoint: string = `${this.endpoint}/?UIDBasket=${carrinho.carrinhoId}&StoreID=${loja.lojaId}`;
            return this.get(
              `REQ_C5_CARRINHO_${carrinho.carrinhoId}`,
              carrinhoEndpoint
            );
          });
      } else {
        return c;
      }
    }
    return c;
  }

  public async updateCarrinho(loja: LojaModel): Promise<any> {
    const carrinho: CarrinhoModel = AppState.getCarrinho();
    const carrinhoAntigo: CarrinhoModel = AppState.getCarrinho();

    let i: number = 0;
    const carrinhoEndpoint: string = `${this.endpoint}/?UIDBasket=${carrinho.carrinhoId}&StoreID=${loja.lojaId}`;
    return this.get(
      `REQ_C5_CARRINHO_${carrinho.carrinhoId}`,
      carrinhoEndpoint
    ).then(async (c: any) => {

      c = await this.limparItensZerados(c, loja);

      const itens: CarrinhoItemModel[] = [];

      for (const p of c.data.products) {
        const prod = await C5ProdutoDAO.getInstance().getById(p.ProductID, loja.lojaId);
        itens.push({
          produto: {
            produtoId: p.ProductID,
            nome: prod?.nome,
            imagem: p.ProductImageCDN,
            precoDesconto: prod?.precoDesconto,
            unidade: p.SaleUnit,
            fatorMultiplicacao: p.WeightMultiplierFactor,
            precoOriginal: prod?.precoOriginal,
          } as ProdutoModel,
          carrinhoItemId: (++i).toString(),
          notas: p.ItemNote,
          quantidade:
            p.SaleUnit === "GR"
              ? p.ItemQuantity / p.WeightMultiplierFactor
              : p.ItemQuantity,
          adicionado: new Date(),
        } as CarrinhoItemModel);
      }

      carrinho.carrinhoItens = itens;

      AppState.forceUpdateCarrinho(carrinho);
      if (c.data.productsInvalid && c.data.productsInvalid.length > 0) {
        const arrNomes = [];

        for (const prod of c.data.productsInvalid) {
          arrNomes.push(prod.ProductName);
          
          await this.remCarrinhoItemAny({
            UIDBasket: carrinhoAntigo.carrinhoId,
            ProductID: prod.ProductID.toString(),
          });
        }

        const plural = arrNomes.length > 1 ? 's' : '';
        return `O produto${plural} ${arrNomes.join(' - ')} foram removidos de seu carrinho porque ficaram indisponíveis`;
      }

    });
  }
}

export default C5CarrinhoDAO;
